import { render } from "./ReactivityTab.vue?vue&type=template&id=2f7197a1&scoped=true"
import script from "./ReactivityTab.vue?vue&type=script&lang=js"
export * from "./ReactivityTab.vue?vue&type=script&lang=js"

import "./ReactivityTab.vue?vue&type=style&index=0&id=2f7197a1&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/dynamic-builder/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f7197a1"]])

export default __exports__